// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ykTAU","buttons":"styles_buttons__3WfuB"};